import React, { useState } from "react";
import { DefaultSettingsT, SettingsT } from "./coursel-slider-settings";
import Carousel from "react-material-ui-carousel";


import {
  Card,
  Box,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { IFeaturesList } from "../../types/featuresList";



const CarouselSlider = (props: {features:  IFeaturesList[], solutionRef: string}) => {
  const [settings, setSettings] = useState<SettingsT>(DefaultSettingsT);

  const items: IFeaturesList[] = props.features;
  
  // [
  //   {
  //     Name: "Do more within each cell",
  //     Caption: "Visually enrich the data within cells using with mini-charts, sparkline trends or highlighters. Explore new perspectives by combining data types, values with visual elements and custom colors.",
  //     ContentPosition: "left",
  //     SlideImage: "FeatureOne.png",
  //   },
  //   {
  //     Name: "Data meets story-telling",
  //     Caption: "Get interactive tool-tips to convey the story behind your data. Give your users the experience of a web page with modern design elements, visuals and a fresh context on your data without interrupting their analysis.",
  //     ContentPosition: "right",
  //     SlideImage: "Mobile_FeatureTwo.png",
  //   },
  //   {
  //     Name: "Dynamic visuals and controls",
  //     Caption: "Break the monotony of native Qlik experience with rich media elements and formatting options. Use icons, images or their links within cells and apply custom styling on data based on conditions.",
  //     ContentPosition: "right",
  //     SlideImage: "Featurethree.png",
  //   },
  // ];


  return (
    <Box sx={{ color: "#494949",pb:2 }}>
      <Carousel
        className="Example"
        navButtonsProps={{          
            style: {
                backgroundColor: '#fff',
                borderRadius: 0,
                color: "#8D8D8D",

            }
        }} 
        activeIndicatorIconButtonProps={{
            style: {
                color: "#F47907",
                fontSize: "12px"
            }
        }}
        
        {...settings}
      >
        {items.map((item, index) => {
          return (
            <Banner
              item={item}
              key={index}
              ContentPosition={item.ContentPosition || "right"}
              solutionRef={props.solutionRef || ""}
            />
          );
        })}
      </Carousel>
    </Box>
  );
};


interface BannerProps {
  item: IFeaturesList;
  ContentPosition: string;//"left" | "right" | "middle";
  length?: number;
  solutionRef: string
}

const Banner = (props: BannerProps) => {
  const ContentPosition = props.ContentPosition
    ? props.ContentPosition
    : "left";
  const totalItems: number = props.length ? props.length : 3;
  const mediaLength = totalItems - 1;

  let items = [];
  const content = (
    <Grid 
      display={"flex"}
      key="content"

      sx={{ border: "1px solid #E8E8EA" }}
      
    >
      <Grid item xs={6}>
        <CardMedia
          className="Media"
          image={"/assets/Images/"+props.solutionRef+"/features/"+props.item.SlideImage}
          title={props.item.Name}
          sx={{ width: "100%", height: "100%" }}
        >

        </CardMedia>
      </Grid>

      <Grid item xs={6}>
        <CardContent className="Content">
          <Typography variant="subtitle1">{props.item.Name}</Typography>

          <Typography variant="body2" color={"#8D8D8D"}>{props.item.Caption} </Typography>

        </CardContent>
      </Grid>
    </Grid>
  );

  items.push(content);


  return (
    <Card raised className="Banner" sx={{ padding: "20px 50px", boxShadow:0 }}>
      <Grid
        container
        spacing={0}
        className="BannerGrid"
        sx={{ minHeight: "200px" }}
      >
        {items}
      </Grid>
    </Card>
  );
};



export default CarouselSlider;
